import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.scss';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Page404, Page500 } from './views/Pages';
import Login from './views/Login/OmniLogin.tsx';
import Register from './views/Login/Register.js';
import Report from './views/Reporting/Report.js';
import Recording from './views/Recording/Recording.js';
import ResetPassword from './views/Login/ResetPassword';
import TT_Report from "./views/Sankey/TT_Report.js";
import ResetPasswordPortal from './views/Login/ResetPasswordPortal';

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login} />
          <Route exact path="/register" name="Register Page" component={Register} />
          <Route exact path="/resetPassword" name="Reset Password Page" component={ResetPassword} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route exact path="/reporting/:type" name="Report" component={Report} />
          <Route exact path="/recording/:recId" name="Recording" component={Recording} />
          <Route exact path="/recording/:recId/:conversationId" name="Recording" component={Recording} />
          <Route exact path="/sankey/report" name="TT Report" component={TT_Report} />
          <Route exact path="/resetPasswordPortal" name="Reset Password" component={ResetPasswordPortal} />
          <Route path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
